import { COUNTNOTREAD, MAILIDROOT, MAILREFESH, TYPEMAIL, EMAILIDOPEN } from './constants';
import { createOrUpdateMailBox, getListMailNotRead } from '../helpers/call-api';

export const setCountNotRead = (value) => {
  return {
    type: COUNTNOTREAD,
    payload: value.count,
  };
};

export const setMailId = (value) => {
  return {
    type: MAILIDROOT,
    payload: value,
  };
};

export const setRefesh = (value) => {
  return {
    type: MAILREFESH,
    payload: value,
  };
};

export const setTypeMail = (value) => {
  return {
    type: TYPEMAIL,
    payload: value,
  };
};

export const setMailIdOpen = (value) => {
  return {
    type: EMAILIDOPEN,
    payload: value,
  };
};

export const updateMail = (mail_id, payload) => async (dispatch) => {
  const object = { mail_id, is_read: 1 };
  await createOrUpdateMailBox(object, payload);
  const unread = await getListMailNotRead(object, payload);
  dispatch(setCountNotRead(unread));
  return unread;
};
